import React from 'react';
import { CompletedInterviewsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CompletedInterviewsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
